
import VLabel from '~/components/ui/VLabel'
import VRadio from '~/components/ui/VRadio'
import VButton from '~/components/ui/VButton'
import VFormGroup from '~/components/ui/VFormGroup'
import BookingTime from '~/components/booking/BookingTime'
import CoworkingBookingLayout from '~/components/modals/booking/CoworkingBookingLayout'
import { COWORKING_SPACE } from '~/constants/api'
import { mapActions, mapState } from 'vuex'
import moment from 'moment'

export default {
    props: {
        item: {
            type: Object,
            required: true,
        },
        buttons: {
            type: Array,
            default: () => []
        }
    },
    mounted() {
        console.log(this.$i18n);
        this.changeData({field: 'price', value: this.item.prices[0]})
        this.changeData({field: 'date', value: new Date().toISOString().split('T')[0]})
    },
    watch: {
        'bookingData.date'(date) {
            this.bookingClean()
            this.getSpaces()
            this.changeData({field: 'price', value: this.item.prices[0]})
            this.changeData({field: 'date', value: date})
        },
    },
    computed: {
        ...mapState('booking', [
            'bookingData'
        ]),
        currentCell() {
            return this.bookingData.cells.find(el => el.id === this.bookingData.space)
            // return this.bookingData.cells.find(el => el.id === this.bookingData.room)
        },
        dateString() {
            if (this.$i18n.localeProperties.code === 'ge') {
                return moment(this.bookingData.date, 'YYYY-MM-DD').toDate().toLocaleDateString(this.$i18n.localeProperties.iso)
            } 
            return moment(this.bookingData.date, 'YYYY-MM-DD').toDate().toLocaleDateString(this.$i18n.localeProperties.iso, {month: "long", day: "numeric", weekday: "long"})
        },
        currentPrice() {
            return this.item.prices.find(el => el.id === this.bookingData.price?.id)
        },
        prices() {
            return this.item.prices.map(el => {
                return {
                    ...el,
                    description: `${el.description} - ${el.formatted}`,
                    id: el.id
                }
            })
        },
        spaces() {
            return this.item.params.spaces
        }
    },
    methods: {
        ...mapActions('booking', [
            'changeData',
            'bookingClean'
        ]),
        getSpaces() {
            if (this.bookingData.room) {
                this.$axios.get(`${COWORKING_SPACE}/${this.bookingData.room}/${this.bookingData.date}/${this.bookingData.date}`).then(res => {
                    this.changeData({field: 'cells', value: res.data.cells})
                })
            }
        },
        changeRoom(id) {
            this.changeData({field: 'room', value: id})
            this.changeData({
                field: 'times',
                value: []
            })
            this.getSpaces()
        },
        changeSpace(id) {
            this.changeData({field: 'space', value: id})
            this.changeData({
                field: 'times',
                value: []
            })
        },
        toggleTime(data) {
            if (this.bookingData.times.find(el => el.cell_id === data.id && el.time === data.item.start)) {
                this.changeData({
                    field: 'times',
                    value: this.bookingData.times.filter(el => el.time !== data.item.start)
                })
            } else {
                this.changeData({
                    field: 'times',
                    value: [
                        ...this.bookingData.times,
                        {
                            time: data.item.start,
                            cell_id: data.id
                        }
                    ]
                })
            }
            this.changeData({
                field: 'calculatedPrice',
                value: `GEL ${(this.currentPrice.amount * this.bookingData.times.length).toFixed(2)}`
            })
        }
    },
    components: {
        VLabel,
        VRadio,
        VButton,
        VFormGroup,
        BookingTime,
        CoworkingBookingLayout
    }
}
